<template>
    <div>
        <div class="px-6">
            <v-btn outlined color="primary" :to="{ name: 'admin-feedback-dashboard' }">
                {{ $t('Takaisin') }}
            </v-btn>
        </div>
        <v-card flat v-if="isLoading" class="text-center pa-8">
            <v-progress-circular indeterminate />
        </v-card>

        <feedback-form v-else-if="feedback" :feedback="feedback" @close="close" />

        <v-alert v-else text type="error">
            {{ $t('Palautetta ei löytynyt') }}
        </v-alert>
    </div>
</template>

<script>
import { onMounted, ref, watch } from "@vue/composition-api";
import adminApi from "@/api/admin";
import feedbackForm from "@/views/admin/feedback/feedback_form_v2.vue";
import { mdiArrowLeft } from "@mdi/js";

export default {
    name: "FeedbackHandle",
    components: {
        feedbackForm,
    },
    props: ["id"],
    setup(props, { root }) {
        const isLoading = ref(false);
        const feedback = ref(null);

        const fetchFeedback = async () => {
            if (!props.id) return;
            isLoading.value = true;
            const res = await adminApi.getFeedback(props.id);
            if (res.ok) {
                feedback.value = res.data;
            } else {
                feedback.value = null;
                alert(res.error);
            }
            isLoading.value = false;
        };

        const close = () => {
            // Prefer going back (keeps context if user came from the old list).
            if (root.$router && root.$router.history && root.$router.history.current) {
                root.$router.back();
            } else {
                root.$router.push({ name: "admin-feedback-dashboard" });
            }
        };

        onMounted(() => {
            fetchFeedback();
        });

        return {
            isLoading,
            feedback,
            close,
            icons: {
                mdiArrowLeft
            }
        };
    },
};
</script>

<style scoped></style>
